module.exports = __webpack_public_path__ + "fonts/bd0a1260564c67a3e138f3372eb70ac2.svg";